<template>
  <div id="pmlst-textpane">
    <div class="pmlst-textpane-wrapper">
      <slot><p>Lorem ipsum dolor sit amet.</p></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'text-pane'
}
</script>
